export default __webpack_public_path__ + "static/media/icon-em-pill-delivered.6536999f.svg";